import { OrderType, OrderState } from '../types/orders';

/**
 * Estados válidos para filtrar por tipo de entidad.
 * Define qué estados tiene sentido mostrar en el dropdown de filtro
 * de cada tabla según la entidad que muestra.
 *
 * REGLA: Partial y Validated son exclusivos de Action.
 * Communication y Accident no participan en el workflow de trabajo.
 *
 * @see BUG #29 en TRACKING_BUGS_TESTING_2026.md
 */
export const ENTITY_VALID_STATES: Partial<Record<OrderType, OrderState[]>> = {
  [OrderType.Action]: [
    OrderState.Partial,
    OrderState.Open,
    OrderState.Validated,
    OrderState.PendingCertification,
    OrderState.Annulled,
    OrderState.End,
  ],
  [OrderType.Generic]: [
    OrderState.Open,
    OrderState.Managed,
    OrderState.PendingWork,
    OrderState.WorkInProgress,
    OrderState.PendingValidation,
    OrderState.PendingATValidation,
    OrderState.Annulled,
    OrderState.End,
  ],
  [OrderType.Campaign]: [
    OrderState.Open,
    OrderState.Managed,
    OrderState.PendingWork,
    OrderState.WorkInProgress,
    OrderState.PendingValidation,
    OrderState.PendingATValidation,
    OrderState.Annulled,
    OrderState.End,
  ],
  [OrderType.Communication]: [
    OrderState.Open,
    OrderState.Annulled,
    OrderState.End,
  ],
  [OrderType.Accident]: [
    OrderState.Open,
    OrderState.Annulled,
    OrderState.End,
  ],
  // V4 (2026-04-21) D5: estados del Recorregut de Vigilància.
  // `managed`, `pending-work`, `work-in-progress` NO aplican — usa `in-progress`/`paused`.
  [OrderType.SurveillanceRoute]: [
    OrderState.Open,
    OrderState.InProgress,
    OrderState.Paused,
    OrderState.PendingValidation,
    OrderState.End,
    OrderState.Annulled,
  ],
  // Tramo del RV (2026-08-05, espejo de VALID_STATES_BY_ENTITY_TYPE del
  // backend): nace `in-progress`, cierra `end`, se anula `annulled`.
  [OrderType.RouteSegment]: [
    OrderState.InProgress,
    OrderState.End,
    OrderState.Annulled,
  ],
  [OrderType.SubOrder]: [
    OrderState.Open,
    OrderState.Managed,
    OrderState.PendingWork,
    OrderState.WorkInProgress,
    OrderState.PendingValidation,
    OrderState.PendingATValidation,
    OrderState.Annulled,
    OrderState.End,
  ],
};

/**
 * Obtiene los estados válidos para filtrar por tipo de entidad.
 * Si el tipo no está definido, retorna todos los estados.
 *
 * @param entityType - Tipo de entidad/orden
 * @returns Array de estados válidos para ese tipo de entidad
 */
export function getValidStatesForEntityType(entityType: OrderType): OrderState[] {
  return ENTITY_VALID_STATES[entityType] ?? Object.values(OrderState);
}
